import client from './client';

const Fssp = {
  getExecutiveProceedings(anketId) {
    return client.get(`/ankets/${anketId}/kf_analytics/fssp`);
  },
};

export default Fssp;
